import { View, Platform } from 'react-native'
import Typography from '@ui/typography'
import AppConfig from 'config'
import { getRemoteConfigFromLocalStorage } from 'hooks/useRemoteConfigStore'

const getRegion = () => {
  const remoteConfig = getRemoteConfigFromLocalStorage()
  const region = remoteConfig
    ? remoteConfig.state?.config?.region?.erpCode
    : undefined
  return typeof region === 'string' ? region : undefined
}

const T = ({ children }: { children: React.ReactNode }) => {
  return (
    <Typography
      variant={Platform.select({ default: 'SM', web: 'SM' })}
      className="color-white/25"
    >
      {children}
    </Typography>
  )
}

const B = ({ children }: { children: React.ReactNode }) => {
  return (
    <Typography
      variant={Platform.select({ default: 'SMB', web: 'SMB' })}
      className="color-white/50"
    >
      {children}
    </Typography>
  )
}

export default function VersionSimpleTag() {
  const version = AppConfig.app.version
  const region = getRegion()

  return (
    <View className="flex h-8 flex-row items-center justify-center gap-2 rounded-sm border border-white/10 bg-white/0 px-4">
      <B>{version}</B>
      {Platform.OS === 'web' && <T>web</T>}
      {Platform.OS === 'ios' && <T>iOS</T>}
      {region && <T>{`${region}`}</T>}
    </View>
  )
}
